import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { SessionService } from 'app/components/common/session/session.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient, private sessionService: SessionService, private router: Router, private location: Location) { }

  getToken(dataIn) {

    let url = ENV.BASE_PATH.USERS + CONSTANTS.END_POINTS.LOGIN.GET_TOKEN;

    return this.http.post(url, dataIn);

  }


  getUser(dataIn) {

    let url = ENV.BASE_PATH.USERS + CONSTANTS.END_POINTS.LOGIN.GET_USER;

    return this.http.get(url);

  }


  checkLoggedUser(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.LOGIN.CHECK_LOGGED_USER + '?eventName=' + dataIn.eventName;

    return this.http.get(url);

  }


  checkAttendee(dataIn) {

    let url = ENV.BASE_PATH.DIGPLATFORM + CONSTANTS.END_POINTS.LOGIN.CHECK_ATTENDEE;

    return this.http.post(url, dataIn);

  }


  logout(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.LOGIN.LOGOUT + '/' + dataIn.catalogueId + '/catalogueUsers/' + dataIn.catalogueUserId + '/logout';

    return this.http.post(url, dataIn);

  }

  isAuth() {
    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

    try {
      if(eventData && Object.keys(eventData).length === 0) {
        const path = this.location.path();
        const segments = path.split('/').filter(Boolean);
        let eventName = segments.find(segment => segment.length > 0) || null;

        eventData = JSON.parse(this.sessionService.get('eventData_' + eventName, true) || '{}');
        this.sessionService.set('eventData', eventData, false);
      }
    } catch (error) {
      eventData = {};
    }

    let token = this.sessionService.get('token_' + eventData['sapCode'], true);
    return token ? true : false;
  }

  redirectToHome() {
    const path = this.location.path();
    const segments = path.split('/').filter(Boolean);
    let eventName = segments.find(segment => segment.length > 0) || null;

    if (!eventName) {
      let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
      let eventName = eventData?.eventName;

      if(!eventName) {
        this.router.navigate(['/hall-list']);
        return;
      }
    }

    this.router.navigate([`${eventName}/home`], { queryParams: { filter: 'ONLY_EXHIBITORS' } });
  }

  removeSessionVariables() {
    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    this.sessionService.remove('token_' + eventData['sapCode'], true);
    this.sessionService.remove('username_' + eventData['sapCode'], true);
    this.sessionService.remove('profile_' + eventData['sapCode'], true);
    this.sessionService.remove('catalogueUser_' + eventData['sapCode'], true);
  }




}
